import React from "react";
import {getDateText} from "./titleSectionHelper";

import styles from "./TitleSection.module.scss";

type TitleSectionProps = {
  title: string;
  venue: string;
  city: string;
  province: string;
  date: string;
};

export default function TtileSection({
  title,
  venue,
  city,
  province,
  date,
}: TitleSectionProps) {
  const eventDateText = getDateText(date);
  return (
    <div className={styles.contentSection}>
      <h1 className={styles.eventTitle}>{title}</h1>
      <p className={styles.eventSubtitle}>
        {venue} • {city}, {province}
      </p>
      <p className={styles.eventSubtitle}>{eventDateText}</p>
    </div>
  );
}
